import { Loader, PageHeader } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import { CreateActivationForm } from '~/features/CreateActivationForm';
import styles from './index.module.scss';

export const Screen: React.FC = () => {
  return (
    <>
      <PageHeader
        variant='breadcrumb'
        breadcrumbItems={[{ label: '利用者一覧', href: '/users' }, { label: '新規追加' }]}
      />
      <div className={styles.content}>
        <span className={styles.content__title}>利用者の新規追加</span>
        <Suspense fallback={<Loader />}>
          <CreateActivationForm />
        </Suspense>
      </div>
    </>
  );
};
